module.exports = __webpack_public_path__ + "media/img/frontend_application/navicon/black-notif-icon-e70991e65443e8a2bff59ea46f4bd505.svg";